
export const findFieldCapability = (module, fieldName) => {
  if (!module) {
    return null;
  }

  const fieldCapability = module.details.find(fieldCap => fieldCap.fieldName === fieldName);

  switch (fieldName) {
    case 'Captcha':
      return fieldCapability !== undefined || false;
    case 'RegistrationId':
      return fieldCapability && fieldCapability.details ?
        fieldCapability.type || null : null;
    default:
      return null;
  }
};
